import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { getMergedReports } from "../connections/getApi";
import { setError, setLoading } from "../redux/slices/pharmacySlice";

const UseFetchMergedReports = ({ patientId, page, perPage, reportType, status, startDate, endDate, medicalTestIds } = {}) => {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ["getMergedReports", patientId, page, perPage, reportType, status, startDate, endDate, medicalTestIds],
    queryFn: () => getMergedReports({ patientId, page, perPage, reportType, status, startDate, endDate, medicalTestIds }),
    enabled: !!patientId,
    keepPreviousData: true,
    onError: () => {
      dispatch(setError(true));
      dispatch(setLoading(false));
    },
    onSettled: () => {
      dispatch(setLoading(false));
    },
  });
};

export default UseFetchMergedReports;
